import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	SeatAssignmentEmpty: {
		k: "seatAssignment.empty.title",
		v: "No details found in check out"
	},
	DescriptionEmpty: {
		k: "seatAssignment.empty.description",
		v: "Please select a course for seat distribution"
	}
});



// WEBPACK FOOTER //
// ./src/panels/checkout/SeatAssignment.labels.ts